export const selectPurchaseBook = state => state.books.purchaseBook
